import { useEffect, useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchInAppQuestionnaires = (id) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchData = useCallback(async () => {
    if (!id) {
      setResponse({ data: null, error: null });
      return;
    }

    startLoading();
    const response = await apiGet(`/assignapps/${id}/index_assignapp_in_app_questionnaires`, "Error al obtener los cuestionarios");
    setResponse(response);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, error, loading, refetch: fetchData };
};

export default useFetchInAppQuestionnaires;
